import React, { useEffect } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import PropTypes from 'prop-types';

import i18n from '@i18n';
import { RecentlyVisitedItemSub } from './RecentlyVisitedItem';
import EmptyState from 'nike-ui/src/components/empty-state/EmptyState';
import ArticleIcon from '@/icons/ArticleIcon';
import { CURRENT_PAGE } from 'nike-ui/src/common/routing';
import DataStateEnum, { PENDING } from '@/common/dataState';
import RecentlyVisitedPending from './RecentlyVisitedPending';
import { fireGAEvent } from '@/analytics';

import { navigate } from '@/routing';
import { NIKE1 } from '@/routing/routes';

function RecentlyVisited({ limited, state, home }) {
    useEffect(() => {
        dispatch(['event:recently-visited.init']);
        return () => dispatch(['event:recently-visited.end']);
    }, []);
    const { derefSub } = useReframe();
    let recentIds = derefSub(['sub::recently-visited.events.ids']);

    if (!recentIds || !recentIds.size) {
        return <EmptyRecentlyVisited />;
    }
    if (state === PENDING) {
        return <RecentlyVisitedPending />;
    }
    return (
        <>
            <div className="top-module">
                <div className="top-live">
                    <div className="items-box">
                        {recentIds.map(eventId => (
                            <RecentlyVisitedItemSub eventId={eventId} key={eventId} />
                        ))}
                    </div>
                </div>
            </div>
            {!home ? <ClearHistory /> : null}
        </>
    );
}

const goToPrematch = () => {
    navigate(NIKE1);
    fireGAEvent(CURRENT_PAGE, 'Prechod do ponuky');
};

const EmptyRecentlyVisited = () => (
    <EmptyState
        text={i18n('recently-visited.empty')}
        stateIcon={<ArticleIcon width={60} height={60} fill={'#aab2bd'} opacity={1} />}
        buttonOnClick={goToPrematch}
        buttonClassName="light-button"
        buttonText={i18n('go-to-prematch')}
    />
);

const ClearHistory = () => (
    <div className="clear-history">
        <button className="light-button" onClick={clearHistory}>
            {i18n('recently-visited.clear')}
        </button>
    </div>
);

function clearHistory() {
    fireGAEvent('Moja Historia', 'Zmazanie historie');
    dispatch(['event:recently-visited.clear']);
}

RecentlyVisited.propTypes = {
    limited: PropTypes.bool,
    visible: PropTypes.bool,
    state: PropTypes.oneOf(Object.keys(DataStateEnum))
};

export default RecentlyVisited;
